module.exports = __webpack_public_path__ + "img/green roads.5ef18810.png";